import React from "react";

const TrusteReviews: React.FC = () => {
  return (
    <div className="flex flex-col mt-4 sm:mt-5">
      <section className="p-4 sm:p-6 md:p-8 bg-[rgb(255,228,228)] text-center">
        <div className="text-[rgb(48,48,48)] text-sm">
          <div className="w-full">
            <div className="leading-none font-['Montserrat'] p-1.5 text-center text-xl sm:text-2xl md:text-[calc(30px+8*((100vw-320px)/960))] lg:text-[30px]">
              <div>
                <h3>
                  <strong>More Trusted Customer Reviews</strong>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-4 sm:mt-5 p-3 sm:p-4 md:p-6 lg:p-8 max-w-7xl mx-auto">
        {/* Reviews Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {/* Column 1 */}
          <div className="space-y-3 sm:space-y-4">
            {/* Review 1 - Shantelle J. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/5748/362537/1719628888-4.jpg"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Shantelle J.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  I saw an online ad for Sonicfit™ and decided to give it a try
                  to help with my stubborn lower belly fat. I've been using
                  Sonicfit™ for 6 weeks now, and I'm amazed by the results! My
                  stomach has visibly reduced in size, and the fat deposit has
                  become less noticeable. I highly recommend using the cream
                  along with the device for enhanced results!
                </p>
              </div>
            </div>

            {/* Review 2 - Jennifer M. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/41178/302481/1711944307-sw4ed5rtf.png"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Jennifer M.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  I bought the Sonicfit™ on a friend's recommendation, and I
                  didn't think a gadget could make me feel good about my body,
                  but here we are! My arms and belly are tighter, and I've gone
                  down a dress size, which is insane. It's simple enough to use
                  – charge it, place it, and let it work its magic. I've always
                  been self-conscious, but now I'm looking forward to a beach
                  vacation for the first time in years. This thing's a
                  confidence booster for sure!
                </p>
              </div>
            </div>

            {/* Review 3 - Melissa C. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/41178/302481/1711944274-4swerdtf.png"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Melissa C.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  I was really skeptical about Sonicfit™ at first, but now I'm a
                  true believer. As someone who's never been into the gym scene,
                  this gadget has been a game-changer. I use it while I'm busy
                  at work, and I've even had to adjust my belt size—it's that
                  effective. It's incredibly easy to use, and I can visibly see
                  the difference in the mirror. I'm feeling more confident about
                  my appearance these days, all thanks to this amazing little
                  tech.
                </p>
              </div>
            </div>
          </div>

          {/* Column 2 */}
          <div className="space-y-3 sm:space-y-4">
            {/* Review 4 - Eleanor K. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/5748/362537/1719628875-2.jpg"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Eleanor K.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  Approaching my late 50s, I struggled with sagging and loose
                  skin on my arms that made me self-conscious. Trying Sonicfit™
                  was a leap of faith, but the results have been remarkable.
                  After consistent use, my arms feel firmer and more toned. The
                  improvement in my skin's elasticity is evident, and I now
                  confidently wear sleeveless tops without hesitation. Sonicfit™
                  has exceeded my expectations, giving me newfound confidence
                  and satisfaction!
                </p>
              </div>
            </div>

            {/* Review 5 - Emily A. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/5748/362537/1719628900-5.jpg"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Emily A.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  After using the Sonicfit™, I'm thrilled with the noticeable
                  reduction in cellulite on my buttocks and legs. It's easy to
                  use and fits perfectly into my skincare routine. The results
                  are impressive—my skin feels smoother and firmer, and the
                  device is gentle yet effective. I highly recommend Sonicfit™
                  for anyone seeking an effective, at-home solution for
                  cellulite reduction.
                </p>
              </div>
            </div>

            {/* Review 6 - Jacqueline B. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Jacqueline B.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  This really works. After using it just once, I felt my skin
                  tightening. I like to use my device right after shower, it's
                  now part of my routine and is easy to use. Cream is a must.
                </p>
              </div>
            </div>
          </div>

          {/* Column 3 */}
          <div className="space-y-3 sm:space-y-4">
            {/* Review 7 - Claudia F. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/41178/302481/1711942981-eswxtrdcyf.png"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Claudia F.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  Using Sonicfit™ has been a game-changer for me! After
                  struggling with stubborn belly fat for years, I decided to
                  give ultrasonic cavitation a try. I couldn't believe the
                  results. In just a few sessions, I noticed a visible reduction
                  in my belly size. The treatment was painless, and I could see
                  the difference in how my clothes fit. Now, I feel more
                  confident and comfortable in my own skin. Sonicfit™ has truly
                  transformed my body, and I'm thrilled with the results!
                </p>
              </div>
            </div>

            {/* Review 8 - Martin S. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/41178/302481/1711944463-aw3se4d6rfytug.png"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Martin S.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  Thank you! Perfect therapy if you want to contour your body. I
                  use it for my skin and cellulite on its L-skin mode with heat.
                  Device seems like high quality and is easy to use. Works
                  wonders!
                </p>
              </div>
            </div>

            {/* Review 9 - Emily J. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Emily J.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  This product showed results in just 2 weeks...I love it!
                </p>
              </div>
            </div>
          </div>

          {/* Column 4 */}
          <div className="space-y-3 sm:space-y-4">
            {/* Review 10 - Monika W. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/41178/302481/1711943056-s54edrytfc.jpeg"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Monika W.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  I initially hesitated to try Sonicfit™ and its ultrasonic
                  cavitation technology, but now I'm thrilled that I did!
                  Managing persistent fat in my belly and legs has been a
                  challenge. Within weeks of using Sonicfit™, I began to see a
                  noticeable decrease in fat around my thighs and belly. My skin
                  feels tighter, and my legs appear more sculpted. I now feel
                  more self-assured and at ease with my body. Sonicfit™ has
                  truly surpassed my expectations!
                </p>
              </div>
            </div>

            {/* Review 11 - Rachel A. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <img
                crossOrigin="anonymous"
                src="//img.funnelish.com/41178/302481/1711944575-se4drtfv.png"
                alt=""
                className="w-full h-auto rounded-t-[20px]"
              />
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Rachel A.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  Never thought I'd write a review, but Sonicfit™ has been a
                  total game-changer for me. With no time or motivation for the
                  gym, this gadget is helping me shed inches right from my
                  couch. I simply strap it on, relax with my favorite shows, and
                  watch it work its magic on my belly fat. My girlfriend noticed
                  I'm looking leaner, and my confidence has soared. If you want
                  to slim down without the gym grind, this device is worth every
                  penny.
                </p>
              </div>
            </div>

            {/* Review 12 - Medina F. */}
            <div className="border border-[rgb(197,199,210)] rounded-[20px] shadow-[0_5px_15px_5px_rgba(197,199,210,0.41)] overflow-hidden">
              <div className="p-2 sm:p-2.5">
                <div className="flex items-start justify-between mb-1.5 sm:mb-2">
                  <p className="font-['Montserrat'] text-sm sm:text-base font-bold text-left m-0">
                    Medina F.
                  </p>
                  <img
                    crossOrigin="anonymous"
                    src="//assets.funnelkonnekt.com/c3586120-cca6-11ed-a5ff-e92bf37fd671/1687872717313_star.png"
                    alt=""
                    className="w-14 sm:w-16 md:w-[77px] h-auto ml-2 sm:ml-2.5 shrink-0"
                  />
                </div>
                <p className="font-['Montserrat'] text-xs sm:text-sm md:text-base leading-[1.6] text-left m-0">
                  I have tried many other brands, but this ONE!, it works
                  awesome, I have never had one complaint with this…Thanks for
                  making such a wonder product.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrusteReviews;
